// extracted by mini-css-extract-plugin
module.exports = {"children":"_1vIe3s8-qa-MfXFaOsU20a"};